import interact from 'interactjs';

export default {
    data: function () {
        return {
            //
        }
    },
    methods: {
        mountedIsSelectable: function () {
            interact(this.$el).on('tap', this.tap);
            interact(this.$el).on('down', this.tap);
        },
        tap: function () {
            $('input').blur();
            if (this.value !== this.index) {
                this.$nextTick(function () {
                    this.$emit('input', this.index);
                    $('html').css('cursor', 'auto');

                    this.$nextTick(function () {
                        EaseEventBus.fire('reinitializeDragula');
                        EaseEventBus.fire('tap', {index: this.index});
                    });
                    EaseEventBus.fire('settingsActive');
                });
            }
        }
    }
};
